import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Dashboard from './Dashboard/Dashboard';
import ItemGrid from './ItemGrid/ItemGrid';
import Login from './Auth/Login';
import PrivateRoute from './Auth/PrivateRoute';
import { AuthProvider } from './Auth/AuthContext';
import './App.css';
import Options from './Dashboard/Options/Options';

const App: React.FC = () => {
  return (
    <Router>
      <AuthProvider>
        <MainLayout />
      </AuthProvider>
    </Router>
  );
};

// Main Layout Component
const MainLayout: React.FC = () => {
  const isAuthenticated = localStorage.getItem('token') !== null;

  return (
    <div className="app-container">
      <Routes>
        <Route path="/login" element={<Login />} />
        {/* Protected Routes */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/items"
          element={
            <PrivateRoute>
              <ItemGrid />
            </PrivateRoute>
          }
        />
          <Route
            path="/options"
            element={
              <PrivateRoute>
                <Options />
              </PrivateRoute>
            }
          />
        {/* Default Route */}
        <Route path="*" element={<Navigate to={isAuthenticated ? '/dashboard' : '/login'} replace />} />
      </Routes>
    </div>
  );
};

export default App;
